import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from "@ngrx/store";
import { AuthSelector } from "../../../states/auth/auth.selectors";
import { StoreSelector } from "../../../states/Store/store.selectors";
import { ItemSelector } from "../../../states/Item/item.selectors";
import { AppointmentSelector } from "../../../states/Appointment/appointment.selectors";
import { StudioSelector } from "../../../states/Studio/studio.selectors";
import { OrderSelector } from 'src/app/states/Order/order.selectors';
import { ItemCategorySelector } from 'src/app/states/ItemCategory/ItemCategory.selectors';

@Component({
	selector: 'app-spinner',
	templateUrl: './spinner.component.html',
	styleUrls: ['./spinner.component.scss'],
	host: { '[id]': 'trackerName' },
	encapsulation: ViewEncapsulation.None,
})
export class SpinnerComponent implements OnInit {
	@Input()
	position: string = 'fixed';
	public showLoader: any = false;
	@Input()
	trackerName = '';

	constructor(
		private store: Store,
	) {
	}

	ngOnInit(): void {
		[
			AuthSelector.selectRequestProcessing,
			StoreSelector.selectRequestProcessing,
			ItemSelector.selectRequestProcessing,
			AppointmentSelector.selectRequestProcessing,
			StudioSelector.selectRequestProcessing,
			OrderSelector.selectRequestProcessing,
			ItemCategorySelector.selectRequestProcessing
		].forEach((requestProcessingFlag) => this.subscribeRequestProcessingState(requestProcessingFlag));
	}

	subscribeRequestProcessingState(requestProcessingFlag): void {
		this.store.pipe(
			select(requestProcessingFlag),
		).subscribe((isRequestProcessing) => {
			this.showLoader = isRequestProcessing;
		});
	}
}
